import { Button, Card, CardBody } from "reactstrap"
import { useNavigate } from "react-router-dom"
import QuotationList from "pages/CustomerPages/CustomerProfile/Quotation/QuotationList"
import { CanView } from "components/Common/CanView"
import { ACCESS } from "constants/accessPermissions"

export default function QuotationsTab({ stock, onChanged }) {
  const navigate = useNavigate()
  const quotations = stock?.quotations || []
  const total = quotations.length ?? 0

  return (
    <Card className="border-0 shadow-sm">
      <CardBody className="p-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h5 className="mb-0 fw-semibold">Quotations</h5>
          <div className="d-flex align-items-center gap-3">
            <div className="text-muted small">Total: {total}</div>
            <CanView access={[ACCESS.CUSTOMER.VIEW_LIST]}>
              <Button
                color="primary"
                size="sm"
                disabled={!stock?.stock_id}
                onClick={() =>
                  navigate(`/quotation-list/add?stock_id=${stock.stock_id}`)
                }
              >
                <i className="bx bx-plus me-1" />
                Add Quotation
              </Button>
            </CanView>
          </div>
        </div>
        <QuotationList data={quotations} onChanged={onChanged} />
      </CardBody>
    </Card>
  )
}
